
import Devices1 from "../../../assets/duotone/Devices1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Devices1Icon({ className, dataTestid = "Devices1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Devices1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
